<template>
  <div class="points-account">
    <div class="points-account-main">
      <div class="points-account-search">
        <el-input
          class="white w320"
          placeholder="请输入客户名称或登录账号"
          @keyup.enter.native="searchAccount"
          v-model="account"
          clearable
        ></el-input>
        <el-button class="btn-blue" @click="searchAccount">搜索</el-button>
        <el-button class="btn-white" @click="exportExcel">导出报表</el-button>
      </div>
      <div class="table" ref="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            v-for="(item, index) in tableTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          ></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                class="btn-text"
                type="text"
                @click="detailed(scope.row)"
                >明细</el-button
              >
              <el-button
                class="btn-text"
                type="text"
                @click="recharge(scope.row)"
                >充值</el-button
              >
              <el-button
                class="btn-text"
                type="text"
                @click="deduction(scope.row)"
                >扣款</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <pagination-tpl
          :total="total"
          :currentPage="page"
          :pageSize="pageSize"
          @queryChange="updatePage"
        ></pagination-tpl>
      </div>
    </div>
    <!-- 充值/扣款 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" top="25vh">
      <!-- 黑色的线条 -->
      <div class="border"></div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="客户名称：" prop="name">
          <el-input v-model="ruleForm.name" class="gray name" placeholder="请输入" disabled></el-input>
        </el-form-item>
        <el-form-item label="积分：" prop="integralVal">
          <el-input v-model.number="ruleForm.integralVal" class="gray" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remarks">
          <el-input v-model="ruleForm.remarks" type="textarea" class="gray" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-white" type="primary" @click="reset('ruleForm')">取消</el-button>
          <el-button class="btn-blue" @click="addDrand('ruleForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Apply from "models/db/apply";
const apply = new Apply();
import PaginationTpl from "base/PaginationTpl";
export default {
  components: {
    PaginationTpl,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 20,
      account: "",
      title: '充值',
      dialogVisible: false,
      isRecharge: true,
      ruleForm: {
        id: '',
        name: "",
        integralVal: "",
        remarks: ""
      },
      rules: {
        integralVal: [
          { required: true, message: "请输入积分", trigger: "blur" },
          { type: "number", message: "必须为0或正整数", min: 0,}
        ],
      },
      tableData: [],
      tableTitle: [
        {label:'客户名称', prop: 'xbName', width: ''},
        {label:'登录账号', prop: 'loginAccount', width: ''},
        {label:'积分总额', prop: 'integralNum', width: ''},
        {label:'已使用积分', prop: 'pointsUsed', width: ''},
        {label:'可使用积分', prop: 'pointsAvailable', width: ''},
        {label:'已过期积分', prop: 'overduePoints', width: ''},
      ]
    };
  },
  created() {
    this.$emit("childMueu", "积分中心", "积分账户", '/admin/apply/integral-content');
    this.initIntegralList()
  },
  methods: {
    /* 翻页 */
    updatePage(data) {
      this.page = data.currentPage;
      this.initIntegralList();
    },
    /* 搜索 */
    searchAccount() {
      this.page = 1;
      this.initIntegralList();
    },
    initIntegralList() {
      let currentPage = this.page
      let name = this.account
      apply.getPointsList(currentPage, name).then((res) => {
        if (res.success) {
          this.total = res.result.totalNum
          let arr = []
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.xbName = i.xbName
            obj.loginAccount = i.username
            obj.integralNum = i.totalPoints
            obj.pointsUsed = i.usedPoints
            obj.pointsAvailable = i.availablePoints
            obj.overduePoints = i.expiredPoints
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      });
    },
    /* 导出报表 */
    exportExcel() {
      let name = this.account;
      apply.getPointsListExcel(name).then((res) => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },
    /* 明细 */
    detailed(row) {
      this.$router.push({
        path: "/admin/apply/integray-detailed",
        query: {
          id: row.id,
          xbName: row.xbName,
          loginAccount: row.loginAccount,
          pointsAvailable: row.pointsAvailable,
        }
      })
    },
    /* 充值 */
    recharge(row) {
      this.title = '充值'
      this.ruleForm.id = row.id
      this.ruleForm.name = row.xbName
      this.isRecharge = true
      this.dialogVisible = true
    },
    /* 扣款 */
    deduction(row) {
      this.title = '扣款'
      this.ruleForm.id = row.id
      this.ruleForm.name = row.xbName
      this.isRecharge = false
      this.dialogVisible = true
    },
    /* 取消 */
    reset(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    /* 保存 */
    addDrand(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let id = this.ruleForm.id;
          let points = this.ruleForm.integralVal;
          let desc = this.ruleForm.remarks;
          let data = {
            id,
            points,
            desc,
          };
          if (this.isRecharge) {
            apply.postRecharge(data).then(res => {
              if (res.success) {
                this.initIntegralList();
                this.reset(formName)
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            apply.postDeduct(data).then(res => {
              if (res.success) {
                this.initIntegralList();
                this.reset(formName)
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.points-account {
  padding: 32px;
  flex: 1;
  overflow: auto;
  .points-account-main {
    background: #fff;
    min-height: 100%;
    padding: 16px;
    box-sizing: border-box;
    .points-account-search {
      height: 64px;
      background: rgba(245, 247, 250, 1);
      border-radius: 4px;
      margin-bottom: 16px;
      padding-left: 16px;
      display: flex;
      align-items: center;
      .w320 {
        width: 320px;
        margin-right: 16px;
      }
      .el-button + .el-button {
        margin-left: 16px;
      }
    }
    .page {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
<style lang="scss">
.points-account {
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }
  .el-input.name .el-input__inner {
    background: #F5F7FA;
    color: #666;
  }
}
</style>